// 导入必要的依赖
import { useCallback, useContext, useEffect, useRef } from 'react';
import './Vidtranslate.less';
import { UploadContext } from '@/context/vidtranslate/UploadContext';
import FileUpload from './components/fileupload/FileUpload';
import PasteVideoUrl from './components/pastevideourl/PasteVideoUrl';
import SyncSelectedImg from '@/assets/vidtranslate/syncSelected.svg';
import Icon from '@/components/iconfont/Icon';
import { useTranslation } from 'react-i18next';
import { EseClosePopup } from '@/hooks/useClosePopup';
import { useDashboardData } from '@/hooks/DashboardHooks';
function Vidtranslate({ onUpload, onCreateSuccess }) {
  const {
    vidtranslateModalShow,
    setVidtranslateModalShow,
    tableItem,
    setTableItem,
    uploadStatus,
    clearData,
    setUploadStatus,
    vidUploadInstance,
    setProgressNum,
    // pasteSubmitLoading,
    setUploadMessage,
    syncModalShow,
    setSyncModalShow,
    setSyncFlag,
    sePastetSyncFlag,
    showAddSubtitles,
    setShowAddSubtitles,
    setTtsState,
    setTranslateState,
    setPasteSubmitLoading,
    setDefaultLanguage,
    popUpClose,
  } = useContext(UploadContext);
  const { languageList: defaultLanguage } = useDashboardData();
  const ModalRef = useRef(null);
  const SyncRef = useRef(null);

  const { t } = useTranslation();

  // 处理弹窗显示和关闭事件
  useEffect(() => {
    if (vidtranslateModalShow) {
      ModalRef.current.show();
    } else {
      if (uploadStatus === 1) {
        setUploadStatus(0);
        vidUploadInstance.stop();
        setProgressNum(0);
      }
      ModalRef.current.close();
      clearData();
      setPasteSubmitLoading(false);
      setShowAddSubtitles(false);
    }
    const dialogElement = ModalRef.current;
    // 添加关闭事件监听
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数:移除事件监听
    return () => {
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vidtranslateModalShow, vidUploadInstance]);
  useEffect(() => {
    if (vidtranslateModalShow) {
      setDefaultLanguage(defaultLanguage);
    }
  }, [vidtranslateModalShow]);

  const handleClose = useCallback(() => {
    if (popUpClose.current) return;
    if (uploadStatus === 1) {
      setUploadStatus(0);
      vidUploadInstance.stop();
      setProgressNum(0);
    }
    setVidtranslateModalShow(false);
    setTtsState(false);
    setTranslateState(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vidtranslateModalShow, uploadStatus]);

  // 处理弹窗显示和关闭事件
  useEffect(() => {
    if (syncModalShow) {
      SyncRef.current.show();
    } else {
      SyncRef.current.close();
    }
  }, [syncModalShow]);

  return (
    <div className="vidtranslate_page">
      <EseClosePopup close={handleClose} />
      <dialog ref={ModalRef} id="my_modal_2" className="modal">
        <div className={`modal-box min-w-[600px]`}>
          <div>
            <div className="vidtranslate_header">
              <div className="text">
                {showAddSubtitles ? t('As_Home_SubtitlePop') : t('As_Home_TranslatePop')}
              </div>
              <Icon name="icon-close-stroke" className="icon" onClick={handleClose} />
            </div>
            <div className="table_box">
              <div
                className={`tab tab1 ${tableItem === 0 && 'tab_active'}`}
                onClick={() => {
                  // if (pasteSubmitLoading) {
                  //   return;
                  // }
                  window.onClickGATrackEvent(
                    showAddSubtitles ? 'addsub-select-upload' : 'translate-select-upload',
                  );
                  setTableItem(0);
                }}>
                <Icon name="icon-upload" className="icon_title" />
                {t('As_Home_LocalFile334')}
              </div>
              <div className="line"></div>
              <div
                className={`tab tab2 ${tableItem === 1 && 'tab_active'}`}
                onClick={() => {
                  // if (pasteSubmitLoading) {
                  //   return;
                  // }
                  window.onClickGATrackEvent(
                    showAddSubtitles ? 'addsub-select-url' : 'translate-select-url',
                  );
                  setTableItem(1);
                  setUploadMessage('');
                }}>
                <Icon name="icon-Youtube" className="icon_title" />
                {t('As_Home_YoutubeLink334')}
              </div>
            </div>
            {vidtranslateModalShow && tableItem === 0 ? (
              <FileUpload onUpload={onUpload} onCreateSuccess={onCreateSuccess} />
            ) : (
              <PasteVideoUrl onUpload={onUpload} onCreateSuccess={onCreateSuccess} />
            )}
          </div>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button>close</button>
        </form>
      </dialog>
      <dialog ref={SyncRef} id="my_modal_2" className="modal">
        <div className={`modal-box min-w-[500px]`}>
          <div className="sync_selected_box">
            <img src={SyncSelectedImg} alt="" />
            <div className="text">
              The generation speed is slow after
              <br />
              lips sync is selected
            </div>
            <div className="btn_box">
              <button
                className="btn btn-outline"
                onClick={() => {
                  window.onClickGATrackEvent('translate-lipsync-confirm');
                  setSyncModalShow(false);
                  if (tableItem === 0) {
                    setSyncFlag(true);
                  } else {
                    sePastetSyncFlag(true);
                  }
                }}>
                {/* Confirm */}
                {t('As_CreateProjectTrans_PopUpConfirm')}
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  window.onClickGATrackEvent('translate-lipsync-cancel');
                  setSyncModalShow(false);
                  if (tableItem === 0) {
                    setSyncFlag(false);
                  } else {
                    sePastetSyncFlag(false);
                  }
                }}>
                {/* Cancel */}
                {t('As_CreateProjectTrans_PopUpCancel')}
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
}

export default Vidtranslate;
